import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onCatalogOptionClick"],
  _excluded2 = ["onCatalogOptionClick"];
let _ = t => t,
  _t;
import { useCallback, useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { H1 } from 'foundations-components/transitional/components/H1';
import { H4 } from 'foundations-components/transitional/components/H4';
import { HR } from 'foundations-components/transitional/components/HR';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { ChatTextInput } from 'academy-common-lib/features/search/components/ChatTextInput';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useUserInfo } from '../../accounts/accountsQueries.legacy';
import I18n from 'I18n';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
// @ts-expect-error bender-url module not typed
import heroImage from 'bender-url!../../../../images/pngs/homepage-hero.webp';
import { useNavPageHandlers } from '../../navigation';
import UsageTracker from '../../../utils/UsageTracker';
import { ACCatalogFilterButton } from 'academy-navigation-lib/components/ACCatalog/ACCatalogFilterButton';
import { ACCatalogMultiSelect } from 'academy-navigation-lib/components/ACCatalog/ACCatalogMultiSelect';
import { ACSearchInput } from 'academy-navigation-lib/components/ACSearchInput/ACSearchInput';
import { useACNavigate } from 'academy-common-lib/hooks/useACNavigate';
import { generatePath } from 'quartz-routing/react-router';
import { ACADEMY_ASSISTANT_URL_FRAGMENT } from '../../../constants/Navigation.legacy';
import HomePageSection from '../../../components/Layouts/HomePageSection';
import { useSearchPlaceholder } from '../searchHooks';
import styledWithTheme from 'foundations-theming/utils';
import { useHasConversations } from 'academy-ai-assistant-lib/components/AcademyAIAssistantChatContainer';
import { Button } from 'foundations-components/transitional/components/Button';
import { RecentlySelectedIcon } from 'foundations-assets/icons/components/RecentlySelectedIcon';
import { useHomeSearchVariant } from '../useHomeSearchVariant';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const HeroImage = styledWithTheme.img(_t || (_t = _`
  display: block;
  inline-size: 100%;
`));
const ChatHistoryButton = ({
  onClick
}) => /*#__PURE__*/_jsx(Button, {
  alignSelf: "start",
  marginBlockStart: "400",
  onClick: onClick,
  use: "unstyled",
  children: /*#__PURE__*/_jsx(Text, {
    color: "fill-accent-magenta-default",
    display: "inline-block",
    typography: "heading-50",
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.getStarted.chatHistory",
      options: {
        icon: /*#__PURE__*/_jsx(RecentlySelectedIcon, {
          alignWithText: true
        })
      }
    })
  })
});
const useChatHistoryNavigation = () => {
  const navigate = useACNavigate();
  const {
    hasConversations
  } = useHasConversations();
  const navigateToAssistant = useCallback(() => {
    UsageTracker.trackStandalone('Assistant Interaction', {
      action: 'open-chat-history'
    });
    navigate(generatePath(ACADEMY_ASSISTANT_URL_FRAGMENT, {
      conversationId: undefined
    }));
  }, [navigate]);
  return {
    hasConversations,
    navigateToAssistant
  };
};
const HomeSearchWithCatalog = () => {
  var _userInfo$user;
  const {
    isMobile,
    isDesktop
  } = useMediaQuery();
  const {
    userInfo
  } = useUserInfo();
  const firstName = userInfo === null || userInfo === void 0 || (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user.firstName;
  const searchPlaceholder = useSearchPlaceholder();
  const _useNavPageHandlers = useNavPageHandlers({
      appearsIn: 'home-search-prompt'
    }),
    {
      onCatalogOptionClick
    } = _useNavPageHandlers,
    searchInputHandlers = _objectWithoutPropertiesLoose(_useNavPageHandlers, _excluded);
  const Header = isMobile ? H4 : H1;
  return /*#__PURE__*/_jsx(HomePageSection, {
    padding: "0",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "300",
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "1500",
        paddingBlockEnd: "900",
        children: [/*#__PURE__*/_jsxs(Flex, {
          flexBasis: 0,
          flexDirection: "column",
          flexGrow: 1,
          gap: "400",
          minInlineSize: "0",
          children: [/*#__PURE__*/_jsx(Header, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.getStarted.header",
              options: {
                firstName
              }
            })
          }), /*#__PURE__*/_jsx(View, {
            minBlockSize: isMobile ? '96px' : '112px',
            children: /*#__PURE__*/_jsxs(Flex, {
              flexDirection: "column",
              gap: "400",
              children: [/*#__PURE__*/_jsx(Text, {
                typography: "body-200",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.getStarted.academyValueProp"
                })
              }), /*#__PURE__*/_jsx(Text, {
                typography: "body-200",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.getStarted.continueOrExplore"
                })
              })]
            })
          }), /*#__PURE__*/_jsx(Flex, {
            "data-onboarding-hook": "search-or-browse-topics",
            flexDirection: "column",
            flexGrow: 1,
            minBlockSize: "0",
            minInlineSize: "0",
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              flexDirection: isMobile ? 'row-reverse' : 'row',
              gap: "400",
              inlineSize: "100%",
              children: [isMobile ? /*#__PURE__*/_jsx(ACCatalogFilterButton, {
                onCatalogOptionClick: onCatalogOptionClick
              }) : /*#__PURE__*/_jsx(ACCatalogMultiSelect, {
                onCatalogOptionClick: onCatalogOptionClick
              }), /*#__PURE__*/_jsx(View, {
                blockSize: "42px",
                flexGrow: 1,
                maxInlineSize: "100%",
                minInlineSize: "0",
                position: "relative",
                zIndex: "3",
                children: /*#__PURE__*/_jsx(View, {
                  inlineSize: "100%",
                  position: "absolute",
                  children: /*#__PURE__*/_jsx(ACSearchInput, Object.assign({
                    placeholder: searchPlaceholder,
                    use: "on-dark"
                  }, searchInputHandlers))
                })
              })]
            })
          })]
        }), isDesktop ? /*#__PURE__*/_jsx(View, {
          alignSelf: "start",
          "aria-hidden": true,
          flexBasis: 0,
          flexGrow: 1,
          minInlineSize: "0",
          children: /*#__PURE__*/_jsx(View, {
            borderRadius: "300",
            overflow: "hidden",
            children: /*#__PURE__*/_jsx(HeroImage, {
              alt: "",
              src: heroImage
            })
          })
        }) : null]
      }), !isMobile ? /*#__PURE__*/_jsx(HR, {
        "data-test-id": "separator",
        distance: "flush"
      }) : null]
    })
  });
};
const HomeSearchWithAssistantTabs = () => {
  var _userInfo$user2;
  const {
    isMobile,
    isTablet,
    isDesktop
  } = useMediaQuery();
  const {
    userInfo
  } = useUserInfo();
  const firstName = userInfo === null || userInfo === void 0 || (_userInfo$user2 = userInfo.user) === null || _userInfo$user2 === void 0 ? void 0 : _userInfo$user2.firstName;
  const navigate = useACNavigate();
  const {
    hasConversations,
    navigateToAssistant
  } = useChatHistoryNavigation();
  const [tab, setTab] = useState('assistant');
  const [assistantInput, setAssistantInput] = useState('');
  const searchPlaceholder = useSearchPlaceholder();
  const _useNavPageHandlers2 = useNavPageHandlers({
      appearsIn: 'home-search-prompt'
    }),
    {
      onCatalogOptionClick
    } = _useNavPageHandlers2,
    searchInputHandlers = _objectWithoutPropertiesLoose(_useNavPageHandlers2, _excluded2);
  const submitAssistantPrompt = useCallback(() => {
    const trimmed = assistantInput.trim();
    if (!trimmed) {
      return;
    }
    UsageTracker.trackStandalone('Assistant Interaction', {
      action: 'prompt-submitted'
    });
    navigate({
      pathname: generatePath(ACADEMY_ASSISTANT_URL_FRAGMENT, {
        conversationId: undefined
      }),
      search: new URLSearchParams({
        initialPrompt: trimmed
      }).toString(),
      hash: '',
      state: {}
    });
  }, [assistantInput, navigate]);
  const onAssistantChatInputChanged = useCallback(e => {
    setAssistantInput(e.target.value);
  }, []);
  const onAssistantKeyDown = useCallback(e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submitAssistantPrompt();
    }
  }, [submitAssistantPrompt]);
  const Header = isMobile ? H4 : H1;
  return /*#__PURE__*/_jsx(HomePageSection, {
    padding: "0",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "1500",
        paddingBlockEnd: "900",
        children: [/*#__PURE__*/_jsxs(Flex, {
          flexBasis: 0,
          flexDirection: "column",
          flexGrow: 1,
          gap: "400",
          minInlineSize: "0",
          children: [/*#__PURE__*/_jsx(Header, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.getStarted.header",
              options: {
                firstName
              }
            })
          }), /*#__PURE__*/_jsx(View, {
            minBlockSize: isMobile ? '96px' : '112px',
            children: /*#__PURE__*/_jsxs(Flex, {
              flexDirection: "column",
              gap: "400",
              children: [/*#__PURE__*/_jsx(Text, {
                typography: "body-200",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.getStarted.assistantWelcome"
                })
              }), /*#__PURE__*/_jsx(Text, {
                typography: "body-200",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.getStarted.assistantLearnPrompt"
                })
              })]
            })
          }), /*#__PURE__*/_jsxs(Flex, {
            "data-onboarding-hook": "search-or-browse-topics",
            flexDirection: "column",
            flexGrow: 1,
            minBlockSize: "0",
            minInlineSize: "0",
            children: [/*#__PURE__*/_jsx(View, {
              inlineSize: "100%",
              minBlockSize: "56px",
              children: /*#__PURE__*/_jsx(Text, {
                as: "span",
                typography: isMobile || isTablet ? 'body-125' : undefined,
                children: /*#__PURE__*/_jsxs(Tabs, {
                  fill: isMobile,
                  inlineSize: "100%",
                  moreTabsRenderer: null,
                  onSelectedChange: e => {
                    const next = e.target.value;
                    if (next === 'assistant' || next === 'legacy') {
                      setTab(next);
                      UsageTracker.trackStandalone('Assistant Interaction', {
                        action: 'tab-selected',
                        tab: next
                      });
                    }
                  },
                  selected: tab,
                  children: [/*#__PURE__*/_jsx(Tab, {
                    tabId: "assistant",
                    title: I18n.text('learningCenter.getStarted.assistantTab')
                  }), /*#__PURE__*/_jsx(Tab, {
                    tabId: "legacy",
                    title: I18n.text('learningCenter.getStarted.searchLegacyTab')
                  })]
                })
              })
            }), /*#__PURE__*/_jsx(Flex, {
              flexDirection: "column",
              flexGrow: 1,
              inlineSize: "100%",
              justifyContent: "start",
              marginBlockStart: "400",
              minBlockSize: "100px",
              minInlineSize: "0",
              children: tab === 'assistant' ? /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx(ChatTextInput, {
                  autoFocus: !isMobile,
                  leadingIcon: null,
                  onChatInputChanged: onAssistantChatInputChanged,
                  onKeyDown: onAssistantKeyDown,
                  onSend: submitAssistantPrompt,
                  placeholder: I18n.text('learningCenter.getStarted.assistantPlaceholder'),
                  value: assistantInput
                }), hasConversations && /*#__PURE__*/_jsx(ChatHistoryButton, {
                  onClick: navigateToAssistant
                })]
              }) : /*#__PURE__*/_jsxs(Flex, {
                alignItems: "center",
                flexDirection: isMobile ? 'row-reverse' : 'row',
                gap: "400",
                inlineSize: "100%",
                children: [isMobile ? /*#__PURE__*/_jsx(ACCatalogFilterButton, {
                  onCatalogOptionClick: onCatalogOptionClick
                }) : /*#__PURE__*/_jsx(ACCatalogMultiSelect, {
                  onCatalogOptionClick: onCatalogOptionClick
                }), /*#__PURE__*/_jsx(View, {
                  blockSize: "42px",
                  flexGrow: 1,
                  maxInlineSize: "100%",
                  minInlineSize: "0",
                  position: "relative",
                  zIndex: "3",
                  children: /*#__PURE__*/_jsx(View, {
                    inlineSize: "100%",
                    position: "absolute",
                    children: /*#__PURE__*/_jsx(ACSearchInput, Object.assign({
                      placeholder: searchPlaceholder,
                      use: "on-dark"
                    }, searchInputHandlers))
                  })
                })]
              })
            })]
          })]
        }), isDesktop ? /*#__PURE__*/_jsx(View, {
          alignSelf: "start",
          "aria-hidden": true,
          flexBasis: 0,
          flexGrow: 1,
          minInlineSize: "0",
          children: /*#__PURE__*/_jsx(View, {
            borderRadius: "300",
            overflow: "hidden",
            children: /*#__PURE__*/_jsx(HeroImage, {
              alt: "",
              src: heroImage
            })
          })
        }) : null]
      }), !isMobile ? /*#__PURE__*/_jsx(HR, {
        "data-test-id": "separator",
        distance: "flush"
      }) : null]
    })
  });
};
const HomeSearchAssistantOnly = () => {
  var _userInfo$user3;
  const {
    isMobile,
    isDesktop
  } = useMediaQuery();
  const {
    userInfo
  } = useUserInfo();
  const firstName = userInfo === null || userInfo === void 0 || (_userInfo$user3 = userInfo.user) === null || _userInfo$user3 === void 0 ? void 0 : _userInfo$user3.firstName;
  const navigate = useACNavigate();
  const {
    hasConversations,
    navigateToAssistant
  } = useChatHistoryNavigation();
  const [assistantInput, setAssistantInput] = useState('');
  const submitAssistantPrompt = useCallback(() => {
    const trimmed = assistantInput.trim();
    if (!trimmed) {
      return;
    }
    UsageTracker.trackStandalone('Assistant Interaction', {
      action: 'prompt-submitted'
    });
    navigate({
      pathname: generatePath(ACADEMY_ASSISTANT_URL_FRAGMENT, {
        conversationId: undefined
      }),
      search: new URLSearchParams({
        initialPrompt: trimmed
      }).toString(),
      hash: '',
      state: {}
    });
  }, [assistantInput, navigate]);
  const onAssistantChatInputChanged = useCallback(e => {
    setAssistantInput(e.target.value);
  }, []);
  const onAssistantKeyDown = useCallback(e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submitAssistantPrompt();
    }
  }, [submitAssistantPrompt]);
  const Header = isMobile ? H4 : H1;
  return /*#__PURE__*/_jsx(HomePageSection, {
    padding: "0",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "300",
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "1500",
        paddingBlockEnd: "900",
        children: [/*#__PURE__*/_jsxs(Flex, {
          flexBasis: 0,
          flexDirection: "column",
          flexGrow: 1,
          gap: "400",
          minInlineSize: "0",
          children: [/*#__PURE__*/_jsx(Header, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.getStarted.header",
              options: {
                firstName
              }
            })
          }), /*#__PURE__*/_jsx(View, {
            minBlockSize: isMobile ? '96px' : '112px',
            children: /*#__PURE__*/_jsxs(Flex, {
              flexDirection: "column",
              gap: "400",
              children: [/*#__PURE__*/_jsx(Text, {
                typography: "body-200",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.getStarted.assistantWelcome"
                })
              }), /*#__PURE__*/_jsx(Text, {
                typography: "body-200",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.getStarted.assistantLearnPrompt"
                })
              })]
            })
          }), /*#__PURE__*/_jsxs(Flex, {
            "data-onboarding-hook": "search-or-browse-topics",
            flexDirection: "column",
            flexGrow: 1,
            minBlockSize: "0",
            minInlineSize: "0",
            children: [/*#__PURE__*/_jsx(ChatTextInput, {
              autoFocus: !isMobile,
              leadingIcon: null,
              onChatInputChanged: onAssistantChatInputChanged,
              onKeyDown: onAssistantKeyDown,
              onSend: submitAssistantPrompt,
              placeholder: I18n.text('learningCenter.getStarted.assistantPlaceholder'),
              value: assistantInput
            }), hasConversations && /*#__PURE__*/_jsx(ChatHistoryButton, {
              onClick: navigateToAssistant
            })]
          })]
        }), isDesktop ? /*#__PURE__*/_jsx(View, {
          alignSelf: "start",
          "aria-hidden": true,
          flexBasis: 0,
          flexGrow: 1,
          minInlineSize: "0",
          children: /*#__PURE__*/_jsx(View, {
            borderRadius: "300",
            overflow: "hidden",
            children: /*#__PURE__*/_jsx(HeroImage, {
              alt: "",
              src: heroImage
            })
          })
        }) : null]
      }), !isMobile ? /*#__PURE__*/_jsx(HR, {
        "data-test-id": "separator",
        distance: "flush"
      }) : null]
    })
  });
};
export const HomeSearchPrompt = () => {
  const variant = useHomeSearchVariant();
  switch (variant) {
    case 'variationA':
      return /*#__PURE__*/_jsx(HomeSearchWithAssistantTabs, {});
    case 'variationB':
      return /*#__PURE__*/_jsx(HomeSearchAssistantOnly, {});
    default:
      return /*#__PURE__*/_jsx(HomeSearchWithCatalog, {});
  }
};
export default HomeSearchPrompt;